<template>
	<div>
		<span class="w-100" id="payment_pending_header"></span>
		<div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="p-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
      <template v-else>
				<!-- PAYMENT SUCCESS -->
				<div v-if="show_success_data" style="min-height:100vh;margin-bottom:-60px;" class="bg-green w-100">
					<div class="px-4" style="padding-top:20%;">
						<div class="mx-auto success-icon-rounded-wrap mb-4">
							<div class="mx-auto success-icon-rounded">
							<img src="../../../assets/img/icon/correct-green.svg" height="50" width="50"> 
							</div>
						</div>
						<div class="w-100 text-center">
							<p class="heading-5 text-white mb-2">{{$t('hotel.concierge.fitur.cart.order-success')}}</p>
							<p class="body-1-3 text-white">{{$t('hotel.concierge.fitur.cart.order-success-desc')}}</p>
						</div>

						<div class="w-100 bg-white radius-12 p-3 mb-5">
							<div class="row no-gutters border-b-semi-grey pb-3 mb-3 cursor-pointer" @click="toggleDetail">
								<div class="col-2 align-self-center">
									<img :src="trx.merchant.image_url" width="35">
								</div>
								<div class="col-9 align-self-center">
									<p class="body-1-2 mb-0">{{trx.module.name}}</p>
									<p class="body-3 mb-0">{{total_ordered}}</p>
								</div>
								<div class="col-1 align-self-center text-right">
									<img src="../../../assets/img/icon/next.png" width="16">
								</div>
							</div>
							<div class="row">
								<div class="col-6">
									<p class="mb-0 body-3-3-1">{{$t('hotel.concierge.invoice')}}</p>
									<p class="mb-0 body-2-1">{{trx.invoice}}</p>
								</div>
								<div class="col-6 text-right">
									<p class="mb-0 body-3-3-1">{{$t('hotel.concierge.total-payment')}}</p>
									<p class="mb-0 body-2-1">{{$formatCurrency(total_bill)}}</p>
								</div>
							</div>
						</div>
						<p class="d-table mx-auto body-1-3 text-white cursor-pointer" @click="goToHome()"><u>{{$t('general.back-to-home')}}</u></p>
					</div>
				</div>

				<template v-else>
					<!-- PAYMENT UNPAID & PENDING -->
					<div v-if="payment.status == 'UNPAID' || payment.status == 'PENDING'" class="w-100">
						<div class="px-4 py-5" v-if="payment.status == 'UNPAID'">
							<wrapper-mobile-view>
								<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
									<div class="w-100">
										<div class="row">
											<!-- <div class="col-1 align-self-center" v-if="direct.show">
												<div @click="toggleConfirmDirect" class="d-inline-grid cursor-pointer">
													<img src="../../../assets/img/icon/back.png" alt="Back" class="mt-1" width="20">
												</div>
											</div> -->
											<div class="col-9 align-self-center">
												<!-- <p class="mb-0 body-1-2">{{direct.show?'Confirm your payment':'Payment pending'}}</p> -->
												<p class="mb-0 body-1-2">Payment pending</p>
											</div>
										</div>
									</div>
								</div>
							</wrapper-mobile-view>
							<block :height="10" />

							<VirtualAccount
								v-if="payment.payment_method == 'VIRTUAL_ACCOUNT' || payment.payment_method == 'BANK_TRANSFER'"
								:data="payment.detail"
								module_page="HOTEL_CONCIERGE"
								:customer_detail="trx.customer_detail" />
							<Qris 
								v-if="payment.payment_method == 'QRIS'"
								:data="payment.detail"
								module_page="HOTEL_CONCIERGE"
								:customer_detail="trx.customer_detail" />
							<button class="g-btn g-btn-secondary g-btn-lg mb-3 w-100" v-if="payment.bank_name == 'DIRECT_PAYMENT'" @click="toggleConfirmPayment()">Confirm Payment</button>
							<button class="g-btn g-btn-primary g-btn-lg w-100" @click="loadFirstData()">{{$t('hotel.action.check-payment-status')}}</button>
							
							<!-- DIRECT PAYMENT CONFIRM -->
							<popup-detail 
								direction="bottom" 
								:show="confirm_payment_show"
								wrapper_size="mobile"
								title="Confirm your payment"
								@close="toggleConfirmPayment">
								<template v-slot:body>
									<div class="p-4 border-t-semi-grey">
										<PaymentConfirm ref="payment_confirm" v-if="confirm_payment_show" :tx_order_id="tx_id" @close="toggleConfirmPayment"></PaymentConfirm>
									</div>
								</template>
							</popup-detail>
						</div>
						<template v-else>
							<div class="w-100 px-4 py-5 bg-orange-soft mb-4 text-center">
								<img src="../../../assets/img/icon/pending.png" width="100" class="position-relative mx-auto mb-4">
								<p class="font-bold mb-3 text-16 text-orange py-2 px-4 bg-white mx-auto d-table" style="border-radius:19px;">Waiting Confirmation</p>
								<p class="font-bold mb-0 text-16 text-white w-100 px-3">Please wait, your booking is being checked</p>
							</div>
							<div class="px-4">
								<div class="w-100 mb-4 bg-white radius-12 p-3 border-semi-grey">
									<div class="row no-gutters mb-3 pb-3 border-b-semi-grey cursor-pointer" @click="toggleDetail">
										<div class="col-2 align-self-center">
											<img :src="getMerchant.image_url" class="w-100">
										</div>
										<div class="col-9 align-self-center">
											<div class="px-3">
												<p class="body-1-2 mb-0">{{getMerchant.name}}</p>
												<p class="body-3-3-1 mb-0">{{total_ordered}}</p>
											</div>
										</div>
										<div class="col-1 align-self-center text-right">
											<i class="iconsmind-Arrow-Right font-weight-bold text-18"></i>
										</div>
									</div>
									<div class="row no-gutters">
										<div class="col-7">
											<p class="body-3-3-1 mb-0">{{$t("general.payment-method")}}</p>
											<p class="body-2-1 mb-0">{{payment.detail.payment_channel.name}}</p>
										</div>
										<div class="col-5 text-right">
											<p class="body-3-3-1 mb-0">{{$t('general.payment-method')}}</p>
											<p class="sub-heading-1-2 mb-0">{{$formatCurrency(payment.detail.total_paid)}}</p>
										</div>
									</div>
								</div>
								<button class="g-btn g-btn-primary g-btn-lg w-100" @click="loadFirstData()">{{$t('hotel.action.check-payment-status')}}</button>
							</div>
						</template>
					</div>

					<!-- PAYMENT FAILED -->
					<div v-if="payment.status == 'CANCELLED'" class="w-100 py-5">
						<div class="px-4">
							<div class="mx-auto failed-icon-rounded-wrap mb-4">
								<div class="mx-auto failed-icon-rounded">
								<img src="../../../assets/img/icon/close-white.png" height="50" width="50"> 
								</div>
							</div>
							<div class="text-center mb-5">
								<p class="heading-5 text-danger mb-2">{{$t('general.payment-failed')}}</p>
								<p class="body-1-3 mb-0">{{$t("hotel.concierge.fitur.your-transaction-has-failed")}}</p>
							</div>

							<!-- JOKUL CC -->
							<template v-if="payment.bank_name == 'JOKUL_DOKU' && payment.payment_method == 'CREDIT_CARD'">
								<p class="body-3-3-1 mb-1">{{$t('hotel.concierge.fitur.detail-error')}}</p>
								<table class="table table-bordered">
									<tbody>
										<tr>
											<td class="body-3-3-1">{{$t('general.payment-method')}}</td>
											<td class="body-3-3-2">{{payment.detail.payment_channel.name}}</td>
										</tr>
										<tr>
											<td class="body-3-3-1">{{$t("hotel.concierge.fitur.masked-card-number")}}</td>
											<td class="body-3-3-2">{{payment.payment_detail_error.card_payment.masked_card_number}}</td>
										</tr>
										<tr>
											<td class="body-3-3-1">{{$t("hotel.concierge.fitur.response-code")}}</td>
											<td class="body-3-3-2">{{payment.payment_detail_error.card_payment.response_code}}</td>
										</tr>
										<tr>
											<td class="body-3-3-1">{{$t("hotel.concierge.fitur.response-message")}}</td>
											<td class="body-3-3-2">{{payment.payment_detail_error.card_payment.response_message}}</td>
										</tr>
										<tr>
											<td class="body-3-3-1">{{$t("hotel.concierge.fitur.issuer")}}</td>
											<td class="body-3-3-2">{{payment.payment_detail_error.card_payment.issuer}}</td>
										</tr>
									</tbody>
								</table>
							</template>

							<button class="g-btn g-btn-secondary g-btn-lg w-100" @click="goToHome()">{{$t('general.back-to-home')}}</button>
						</div>
					</div>
				</template>

				<!-- DETAIL -->
				<popup-detail 
					id_ref="trx_detail"
					direction="bottom" 
					:show="show_detail"
					use_max_size
					wrapper_size="mobile"
					use_footer
					@close="toggleDetail">
					<template v-slot:body>
						<template v-if="trx.id">
							<div class="p-4">
								<div class="row">
									<div class="col-6">
										<p class="mb-0 body-3">Invoice</p>
										<p class="mb-0 body-2-4">{{trx.invoice}}</p>
									</div>
									<div class="col-6">
										<p class="mb-0 body-3">Transaction Date</p>
										<p class="mb-0 body-2-4">{{$formatDateTime(trx.created_at)}}</p>
									</div>
									<div class="col-12 my-4">
										<div class="w-100 border-b-semi-grey">
										</div>
									</div>
								</div>
							</div>
							<template v-if="trx.module.slug == 'experience'">
								<div class="w-100 px-4">
									<div class="row no-gutters">
										<div class="col-4">
											<div class="w-100">
												<img :src="merchant_booked.image_url" class="w-100 radius-6">
											</div>
										</div>
										<div class="col-8">
											<div class="pl-3">
												<p class="mb-1 body-1-4">{{ merchant_booked.name }}</p>
												<p class="mb-1 body-2-2">{{ $formatDate(service_date) }}</p>
											</div>
										</div>
									</div>
									<div class="w-100 border-b-semi-grey-dashed my-3"></div>
									<p class="mb-3 sub-heading-1-1">Selected Tickets</p>
									<template v-for="(product,index) in trx.tx_detail_list">
										<div class="p-3 radius-6 mb-3 border-semi-grey">
											<div class="row slim-grid-row">
												<div class="align-self-center col-10">
													<p class="mb-1 body-2-4">{{product.product_name}}</p>
													<p class="mb-1 body-2-1 text-orange" v-if="product.variant_name != null">{{ product.variant_name }}</p>
													<p class="mb-0 body-2-1">{{ $formatCurrency(product.subtotal_sell)}}</p>
												</div>
												<div class="align-self-center col-2 text-right">
													<p class="mb-0 body-1-4 text-orange">{{product.qty}}X</p>
												</div>
											</div>
										</div>
									</template>
								</div>
								<div class="w-100 border-b-semi-grey my-4"></div>
								<div class="w-100 px-4">
									<p class="mb-3 sub-heading-1-1">Note</p>
									<textarea placeholder="-" disabled v-model="trx.notes" class="form-control p-3 body-2-2 rounded-6 mb-2" rows="2"></textarea>
								</div>
								<div class="w-100 border-b-semi-grey my-4"></div>
								<div class="w-100 px-4">
									<p class="mb-3 sub-heading-1-1">Payment</p>
									<div class="p-3 radius-6 border-semi-grey">
										<p class="w-100 body2-4" v-if="payment.status == 'PAY_LATER'">Pay at hotel</p>
										<template v-else>
											<div class="row">
												<div class="col-6">
													<p class="mb-0 body-2-2">Payment method</p>
												</div>
												<div class="col-6">
													<p class="mb-0 body-2-4 text-right w-100">{{payment.detail.payment_channel.name}}</p>
												</div>
												<div class="col-12">
													<div class="w-100 border-b-semi-grey-dashed my-3"></div>
												</div>
												<div class="col-6">
													<p class="mb-0 body-2-2">Payment time</p>
												</div>
												<div class="col-6">
													<p class="mb-0 body-2-4 text-right w-100">{{$formatDateTime(payment.created_at)}}</p>
												</div>
												<div class="col-12">
													<div class="w-100 border-b-semi-grey-dashed my-3"></div>
												</div>
												<div class="col-6">
													<p class="mb-0 body-2-2">Status</p>
												</div>
												<div class="col-6">
													<p class="mb-0 body-2-4 text-right w-100" :class="payment.status == 'SUCCESS'?'text-success':'text-danger'">{{payment.status}}</p>
												</div>
											</div>
										</template>
									</div>
								</div>
								<div class="w-100 border-b-semi-grey my-4"></div>
								<div class="w-100 px-4 mb-4">
									<p class="mb-3 sub-heading-1-1">Price Detail</p>
									<div class="p-3 border-b-semi-grey-dashed">
										<p class="mb-3 body-1-2">{{$t('hotel.concierge.price-detail')}}</p>
										<div class="row no-gutters mb-2">
											<div class="col-6">
												<p class="mb-0 body-2-1">{{$t('hotel.concierge.sub-total')}}</p>
											</div>
											<div class="col-6 text-right">
												<p class="mb-0 body-2-1">{{$formatCurrency(trx.total_amount)}}</p>
											</div>
										</div>
										<div class="row no-gutters mb-2">
											<div class="col-6">
												<p class="mb-0 body-2-1">{{$t('hotel.concierge.discount')}}</p>
											</div>
											<div class="col-6 text-right">
												<p v-if="Math.abs(parseFloat(trx.total_discount)) == 0" class="mb-0 body-2-1">{{$formatCurrency(Math.abs(parseFloat(trx.total_discount)))}}</p>
												<p v-else class="mb-0 body-2-1 text-orange">-{{$formatCurrency(Math.abs(parseFloat(trx.total_discount)))}}</p>
											</div>
										</div>
										<div class="row no-gutters">
											<div class="col-6">
												<p class="mb-0 body-2-1">{{$t('hotel.concierge.tax-service')}}</p>
											</div>
											<div class="col-6 text-right">
												<p class="mb-0 body-2-1">{{$formatCurrency(parseFloat(trx.total_taxes)+parseFloat(trx.total_service))}}</p>
											</div>
										</div>
										<div class="row no-gutters mt-2" v-if="payment_surcharge > 0">
											<div class="col-6">
												<p class="mb-0 body-2-1">Payment Surcharge</p>
											</div>
											<div class="col-6 text-right">
												<p class="mb-0 body-2-1">{{$formatCurrency(payment_surcharge)}}</p>
											</div>
										</div>
									</div>
									<div class="p-3">
										<div class="row no-gutters">
											<div class="col-5">
												<p class="mb-0 body-1-2">{{$t('hotel.concierge.total')}}</p>
											</div>
											<div class="col-7 text-right">
												<p class="mb-0 sub-heading-1-1">{{$formatCurrency(total_bill)}}</p>
											</div>
										</div>
									</div>
								</div>
							</template>
							<div class="p-4" v-else>
								<div class="w-100 mb-4">
									<div class="w-100 mb-2 p-2 radius-6 border-semi-grey" v-for="(product,index) in trx.tx_detail_list" :key="index">
										<div class="row no-gutters">
											<div class="col-2 align-self-center">
												<img :src="product.product_image" class="w-100 radius-6" >
											</div>
											<div class="col-8 align-self-center">
												<div class="pl-2">
													<p class="body-2-1 mb-0">{{product.product_name}}</p>
													<p v-if="product.variant_name != null || splitNotes(product.notes,'variant') != ''" class="body-3-1 mb-0">Variant : {{product.variant_name != null ? product.variant_name : splitNotes(product.notes,'variant')}}</p>
													<p class="body-3-3-1 mb-0 text-green">{{$formatCurrency(product.subtotal_sell)}}</p>
												</div>
											</div>
											<div class="col-2 align-self-center text-right">
												<p class="mb-0 body-1-4 text-orange pr-2">{{product.qty}}X</p>
											</div>
											<template v-if="trx.module.slug != 'experience'">
												<div class="col-12 my-2">
													<div class="w-100 border-b-semi-grey-dashed"></div>
												</div>
												<div class="col-12">
													<p class="body-3-3-1 mb-0">Note : {{product.notes != null ? splitNotes(product.notes,'notes') : '-'}}</p>
												</div>
											</template>
										</div>
									</div>
								</div>
								<div class="w-100 radius-6 border-semi-grey p-3 mb-4">
									<p class="mb-0 body-1-2 w-100">Notes</p>
									<p class="mb-0 body-2-2">{{!(trx.notes == null || trx.notes == '') ? trx.notes : ''}}</p>
								</div>
								<div class="w-100 radius-6 border-semi-grey mb-4">
									<div class="p-3 border-b-semi-grey-dashed">
										<p class="mb-3 body-1-2">{{$t('hotel.concierge.price-detail')}}</p>
										<div class="row no-gutters mb-2">
											<div class="col-6">
												<p class="mb-0 body-2-1">{{$t('hotel.concierge.sub-total')}}</p>
											</div>
											<div class="col-6 text-right">
												<p class="mb-0 body-2-1">{{$formatCurrency(trx.total_amount)}}</p>
											</div>
										</div>
										<div class="row no-gutters mb-2">
											<div class="col-6">
												<p class="mb-0 body-2-1">{{$t('hotel.concierge.discount')}}</p>
											</div>
											<div class="col-6 text-right">
												<p v-if="Math.abs(parseFloat(trx.total_discount)) == 0" class="mb-0 body-2-1">{{$formatCurrency(Math.abs(parseFloat(trx.total_discount)))}}</p>
												<p v-else class="mb-0 body-2-1 text-orange">-{{$formatCurrency(Math.abs(parseFloat(trx.total_discount)))}}</p>
											</div>
										</div>
										<div class="row no-gutters">
											<div class="col-6">
												<p class="mb-0 body-2-1">{{$t('hotel.concierge.tax-service')}}</p>
											</div>
											<div class="col-6 text-right">
												<p class="mb-0 body-2-1">{{$formatCurrency(parseFloat(trx.total_taxes)+parseFloat(trx.total_service))}}</p>
											</div>
										</div>
									</div>
									<div class="p-3">
										<div class="row no-gutters">
											<div class="col-5">
												<p class="mb-0 body-1-2">{{$t('hotel.concierge.total')}}</p>
											</div>
											<div class="col-7 text-right">
												<p class="mb-0 sub-heading-1-1">{{$formatCurrency(total_bill)}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</template>
					<template v-slot:footer>
						<div class="px-3 pt-3">
							<button 
								@click="toggleDetail"
								class="ga-btn-primary-lg" >
								Close
							</button>
						</div>
					</template>
				</popup-detail>
			</template>
		</template>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import {get} from '@/services/index.js'
	import VirtualAccount from '@/components/general/payment/VirtualAccount'
	import Qris from '@/components/general/payment/Qris'
	import PaymentConfirm from '../../../components/general/payment/PaymentConfirm.vue'
  import { trackPageViewAfterDataLoaded } from '../../../utils/analytics'
  import { applyResolvedTitle } from '../../../utils/titleService'

	export default {
		components:{
			VirtualAccount,
			Qris,
			PaymentConfirm
		},
		data() {
			return {
				is_load: false,
				error: '',
				original_data: {},
				trx: {},
				payment: {},
				show_detail: false,
				confirm_payment_show: false,
				merchant_booked: {},
				service_date: null
			}
		},
		computed:{
			...mapGetters(['getMerchant']),
			tx_id(){
				return this.$route.params.trx_id
			},
			payment_surcharge(){
				let data = 0
				if(this.payment.status && this.payment.status != 'PAY_LATER'){
					data = this.payment.detail.payment_surcharge
				}
				return Number(data)
			},
			total_bill(){
				let data = 0 
				if(this.trx.id){
					data = Number(this.trx.total_payment)
				}
				if(this.payment_surcharge > 0){
					data += this.payment_surcharge
				}
				return data 
			},
			show_success_data(){
				let is_payment = this.payment.status
				let is_pay_later = is_payment && this.payment.status == 'PAY_LATER'
				let is_paid = is_payment && this.payment.status == 'SUCCESS'
				return is_pay_later || is_paid
			},
			total_ordered(){
				let qty = 0
				let unit = 'item'
				let book_word = 'ordered'

				if(this.trx.id){
					qty = this.trx.tx_detail_list.reduce((acc, x)=>acc + x.qty, 0)
					if(this.trx.module.slug == 'room-dining'){
						unit = 'menu'
					}else if(this.trx.module.slug == 'laundry' || this.trx.module.slug == 'spa'){
						unit = 'service'
						book_word = 'booked'
					}else if(this.trx.module.slug == 'experience'){
						unit = 'activity'
						book_word = 'booked'
					}

					if(unit == 'activity'){
						if(qty > 1){
							unit = 'activities'
						}
					}else{
						unit = this.$pluralWord(qty,unit)
					}
				}

				return `${qty} ${unit} ${book_word}`
			}
		},
		mounted(){
			this.loadFirstData()
		},
		methods: {
			loadFirstData() {
				this.is_load = true
				this.error = ''
				this.original_data = {}
				this.trx = {}
				this.payment = {}

				Promise.all([
					this.loadTrxDetailFromAPI()
				]).then(res=>{
					// save original & payment data
					let trx_res = res[0]
					this.original_data = trx_res
					this.trx = trx_res
					if(this.trx.module.slug == 'experience'){
						this.merchant_booked = this.trx.tx_detail_list[0].merchant_relation
						this.service_date = this.trx.tx_detail_list[0].service_date
					}
					this.getDetailPayment(trx_res.tx_payment_list)

          this.setPageTitleAndTrack();
          
					// save trx data without payment
					let clone_data = this.$deepCopy(trx_res)
					delete clone_data.tx_payment_list
					this.trx = clone_data
				}).catch(err=>this.error = err).finally(()=>this.is_load = false)
			},
			loadTrxDetailFromAPI(){
				return new Promise((success,fail)=>{
					get("CORE_HOTEL",`merchant-pos/transaction/${this.tx_id}`,{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						let res = response.data
						if(res.success){
							success(res.data)
						}else{
							fail(res.message)
						}
					})
				})
			},
			getDetailPayment(payment){
				if(payment.length == 0){
					this.payment.status = 'PAY_LATER'
				}else{
					let clone_data = this.$deepCopy(payment[0].tx_bill_payment)
					this.payment = {
						status: clone_data.status,
						bank_name: clone_data.payment_channel.payment_gateway.pg_company,
						pg_mode: clone_data.payment_channel.payment_gateway.pg_mode,
						payment_method: clone_data.payment_channel.channel,
						pg_response: JSON.parse(clone_data.inq_resp_detail),
						created_at: payment[0].created_at,
						detail: clone_data,
						payment_detail_error: clone_data.pay_resp_detail == null ? null : JSON.parse(clone_data.pay_resp_detail)
					}
				}
			},
      setPageTitleAndTrack(){
        const { status = "PENDING" } = this.payment;
        const { pos: { tagline = null } } = this.trx;
        const isPaymentPending = status === 'PENDING';
        const isPaymentCancelled = status === 'CANCELLED';
        
        let title = 'Booking Confirmed';

        if(isPaymentPending) title = 'Payment Pending';
        if(isPaymentCancelled) title = 'Booking Failed';
        const params = {
          router: this.$router,
          title: tagline ? `${title} - ${tagline}` : title,
          trackFn: () => trackPageViewAfterDataLoaded()
        }
        
        applyResolvedTitle(params);
      },
			toggleDetail(){
				this.show_detail = !this.show_detail
			},
			goToHome(){
				this.$router.push(`/${this.getMerchant.code}`)
			},
			splitNotes(data,type='variant'){
				if(data != null){
					let arr_note = data.split(';')
					if(arr_note.length == 1){
						return data
					}else if(arr_note.length > 1){
						if(type == 'variant'){
							return arr_note[0]
						}else{
							return arr_note.slice(1,arr_note.length).join()
						}
					}else{
						return data
					}
				}else{
					return ''
				}
			},
			toggleConfirmPayment(){
				let is_payment_confirm_exist = this.$refs.payment_confirm
				if(this.confirm_payment_show && is_payment_confirm_exist && is_payment_confirm_exist.result_push == 'success'){
					this.loadFirstData()
				}
				this.confirm_payment_show = !this.confirm_payment_show
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/TrxResult.vue